<template>
  <div class="connection-message">
    <v-icon
      small
      color="white"
      class="connection-message__icon"
    >
      {{ message.icon }}
    </v-icon>
    <b class="connection-message__title">{{ message.title }}</b>
    <span
      v-if="message.text"
      class="connection-message__text"
    >
      {{ message.text }}
    </span>
    <v-btn
      v-if="mode === 'server' || mode === 'api'"
      x-small
      outlined
      color="white"
      class="connection-message__btn"
      :loading="refreshing"
      @click="refresh"
    >
      Обновить
      <!-- Свой лоадер: штатный 23px вылезает из кнопки x-small высотой 20px -->
      <template #loader>
        <v-progress-circular
          indeterminate
          size="12"
          width="2"
        />
      </template>
    </v-btn>
  </div>
</template>

<script>
  import { refreshService } from '@/services/refresh'

  // server - интернет есть, но заказы не приходят мгновенно: их проверяет
  // сторож раз в 30 секунд, а звук нового заказа приходит только по сокету.
  // api - сервер не ответил на три пробы сторожа подряд; сторож повторяет пробу
  // каждые 20 секунд и снимет полосу сам
  const MESSAGES = {
    offline: {
      icon: 'mdi-wifi-off',
      title: 'Нет подключения к интернету.',
      text: 'Заказы на экране не обновляются — проверьте Wi-Fi или кабель',
    },
    api: {
      icon: 'mdi-server-off',
      title: 'Сервер недоступен.',
      text: 'Заказы на экране не обновляются - мы пробуем снова',
    },
    server: {
      icon: 'mdi-cloud-off-outline',
      title: 'Заказы обновляются с задержкой.',
      text: 'Новые заказы появятся в течение 30 секунд, звук нового заказа может не сработать',
    },
    restored: {
      icon: 'mdi-check-circle-outline',
      title: 'Связь восстановлена',
      text: '',
    },
  }

  export default {
    name: 'ConnectionMessage',
    props: {
      // offline | api | server | restored
      mode: {
        type: String,
        required: true,
      },
    },
    data () {
      return { refreshing: false }
    },
    computed: {
      message () {
        return MESSAGES[this.mode]
      },
    },
    methods: {
      // Проба нужна, чтобы успешный ответ снял «Сервер недоступен», полный проход -
      // потому что пользователь ждёт данных
      async refresh () {
        this.refreshing = true
        try {
          await refreshService.run({ probe: true, force: true })
        } finally {
          this.refreshing = false
        }
      },
    },
  }
</script>

<style scoped lang="less">
.connection-message {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;

  // Отступы margin'ом, а не gap: flex gap не знают Safari до 14.1 и IE
  &__icon {
    margin-right: 6px;
  }

  &__title {
    margin-right: 4px;
    font-weight: 700;
  }

  &__btn {
    margin-left: 12px;
  }

  // На узком экране по центру иконка, заголовок, пояснение и кнопка рассыпались
  // по строкам вразнобой. Здесь заголовок с кнопкой - первой строкой, пояснение
  // мельче под заголовком, всё прижато влево
  .media-sm({
    width: 100%;
    justify-content: flex-start;
    text-align: left;

    &__title {
      flex: 1;
      margin-right: 0;
    }

    &__btn {
      margin-left: 8px;
    }

    &__text {
      order: 1;
      flex-basis: 100%;
      margin-top: 2px;
      // Ширина иконки с её полем - пояснение встаёт ровно под заголовок
      padding-left: 22px;
      font-size: 12px;
      opacity: 0.9;
    }
  });
}
</style>
